<template>
    <div class="input-text postcode">
        <InputText
            type="text"
            v-model="postcodeValue"
            :name="`${step.name}[${data.element_details.name}]`"
            inputmode="numeric"
            pattern="[0-9]{5}"
            maxlength="5"
            style="width: 100%;"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    data:Object,
    field:Object,
    step:Object,
})

defineEmits(['update:modelValue'])

const postcodeValue = computed({
    get() {
        return props.field.value ?? '';
    },
    set(value) {
        props.field.value = normalizePostcode(value);
    }
});

function normalizePostcode(value) {
    return String(value ?? '').replace(/\D/g, '').slice(0, 5);
}
</script>